/* eslint-disable max-len */
import React from 'react';

import { makeStyles, FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

import { UPLOAD_OPTIONS } from '../../constants/general';

const useStyles = makeStyles((theme) => {
  return {
    fieldContainer: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '90%',
      },
    },
    fieldParentContainer: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'no-wrap',
    },
    normalWrap: {
      '& .MuiSelect-selectMenu': {
        whiteSpace: 'normal',
      },
    },
    typographyMenu: {
      color: theme.palette.primary.main,
    },
    typographyTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '16px',
      marginBottom: '8px',
      marginTop: '24px',
    },
  };
});

export default ({ imageUploadOption, onImageUploadOptionChange = () => {}, studies = [] }) => {
  const classes = useStyles();

  const handleRadioChange = (_event, value) => {
    onImageUploadOptionChange(value);
  };

  return (
    <div className="text-left" style={{ maxWidth: '672px', width: '100%' }}>
      <div className={classes.fieldParentContainer}>
        <FormControl fullWidth className={classes.fieldContainer}>
          <p className={classes.typographyTitle}>File Upload Method</p>
          <RadioGroup onChange={handleRadioChange} value={imageUploadOption}>
            {studies?.length ? (
              <FormControlLabel
                control={<Radio color="primary" checked={imageUploadOption === UPLOAD_OPTIONS.USE_EXISTING_STUDY} />}
                label={<span style={{ fontWeight: imageUploadOption === UPLOAD_OPTIONS.USE_EXISTING_STUDY ? 'bold' : '' }}>Use a study from my personal medical record</span>}
                value={UPLOAD_OPTIONS.USE_EXISTING_STUDY}
              />
            ) : null}

            <FormControlLabel
              control={<Radio color="primary" checked={imageUploadOption === UPLOAD_OPTIONS.UPLOAD_SELF} />}
              label={<span style={{ fontWeight: imageUploadOption === UPLOAD_OPTIONS.UPLOAD_SELF ? 'bold' : '' }}>I will upload my own files</span>}
              value={UPLOAD_OPTIONS.UPLOAD_SELF}
            />

            <FormControlLabel
              control={<Radio color="primary" checked={imageUploadOption === UPLOAD_OPTIONS.ONLINE_PORTAL_ACCESS} />}
              label={
                <span style={{ fontWeight: imageUploadOption === UPLOAD_OPTIONS.ONLINE_PORTAL_ACCESS ? 'bold' : '' }}>
                  I will allow Mediphany to access images from my online portal
                </span>
              }
              value={UPLOAD_OPTIONS.ONLINE_PORTAL_ACCESS}
            />

            <FormControlLabel
              control={<Radio color="primary" checked={imageUploadOption === UPLOAD_OPTIONS.FOLDER_SHARE_LINK} />}
              label={
                <span style={{ fontWeight: imageUploadOption === UPLOAD_OPTIONS.FOLDER_SHARE_LINK ? 'bold' : '' }}>
                  Get MRI images from my online folder (Google Drive/Dropbox/other)
                </span>
              }
              value={UPLOAD_OPTIONS.FOLDER_SHARE_LINK}
            />
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};
